import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const ButtonLink = ({ to, children, variant = "primary", className = "", testId, arrow = false }) => {
  const base =
    "inline-flex items-center justify-center gap-3 border px-8 py-4 font-mono text-xs uppercase tracking-[0.2em] transition-colors duration-300 rounded-none";
  const styles = {
    primary: "border-charcoal bg-charcoal text-canvas hover:bg-transparent hover:text-charcoal",
    outline: "border-charcoal bg-transparent text-charcoal hover:bg-charcoal hover:text-canvas",
    light: "border-[#F5F5F0] bg-[#F5F5F0] text-obsidian hover:bg-transparent hover:text-[#F5F5F0]",
    outlineLight: "border-darkborder bg-transparent text-[#F5F5F0] hover:border-[#F5F5F0]",
  };
  const cls = `${base} ${styles[variant]} ${className}`;
  if (to && to.startsWith("http")) {
    return (
      <a href={to} target="_blank" rel="noopener noreferrer" data-testid={testId} className={cls}>
        {children}
        {arrow && <ArrowUpRight className="h-4 w-4" strokeWidth={1.5} />}
      </a>
    );
  }
  return (
    <Link to={to} data-testid={testId} className={cls}>
      {children}
      {arrow && <ArrowUpRight className="h-4 w-4" strokeWidth={1.5} />}
    </Link>
  );
};

export default ButtonLink;
